import { useAuth, AuthStatus } from '../auth/Auth';
import { SubscriptionStatus } from '../database/user';

/**
 * Returns whether the current user has full access to forum content.
 * Access is granted to subscribed users, users with subscription override,
 * admins, and the artist.
 */
export const useHasForumAccess = (): boolean => {
    const auth = useAuth();

    if (auth.status !== AuthStatus.Authenticated || !auth.user) {
        return false;
    }

    return (
        auth.user.subscriptionStatus === SubscriptionStatus.SUBSCRIBED ||
        !!auth.user.subscriptionOverride ||
        auth.user.isAdmin ||
        auth.user.isArtist
    );
};
